/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Letter/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Edit from './Edit/index'
import Generate from './Generate/index'
import No from './No/index'
import Preview from './Preview/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Letter({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Content/Actions/Action/Letter"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let actionValueData = fromData.useDataFormat({ viewPath,
context: 'action',
format: fromHelpers.view,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: actionValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Edit'}>
<Edit
  viewPath={`${viewPath}/Edit`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Generate'}>
<Generate
  viewPath={`${viewPath}/Generate`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Preview'}>
<Preview
  viewPath={`${viewPath}/Preview`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}